import axios from "../axios";
import api from "../api";

export const state = {
  prompts: {
    prompt1: {},
    prompt2: {},
    prompt3: {},
    prompt4: {}
  },
}

export const mutations = {
  SET_WIN_BACK_PROMPTS_V1 (state, value) {
    state.prompts = value;
  },
  UPDATE_WIN_BACK_PROMPT_V1 (state, {step, value}) {
    state.prompts[step] = value
  }
}
export const actions = {
  async get_win_back_prompts_v1 ({commit}) {
    try {
      commit('SET_REQ_STATUS', 'loading')
      const { data } = await axios.get(`${api.personalized_emails.settings}/prompts-win-back-took-2-months-off`);
      commit('SET_WIN_BACK_PROMPTS_V1', data);
      commit('SET_REQ_STATUS', 'idle')
    } catch (err) {
      console.log(err)
      commit('SET_REQ_STATUS', 'failed')
    }
  },
  async save_win_back_prompts_v1 ({state, commit}, key) {
    try {
      commit('SET_REQ_STATUS', `saving-${key}`)
      await axios.put(`${api.personalized_emails.settings}/prompts-win-back-took-2-months-off`, {[key]: state.prompts[key]});
      commit('SET_REQ_STATUS', 'idle')
    } catch (err) {
      console.log(err)
      commit('SET_REQ_STATUS', 'failed')
    }
  }
}